module.exports = __webpack_public_path__ + "media/images/athletes/1655-d42426cfd198e2616e73ae06d0e045d6.png";